"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contour = void 0;
const gl_matrix_1 = require("gl-matrix");
const ShapeHelper_1 = require("./ShapeHelper");
/**
 * Contour Shape
 */
class Contour {
    /**
     * Private constructor, use static creation methods instead.
     *
     * @param polygon Polygon that describes the contour shape. The polygon doesn't have to be convex.
     * @param area Area of the contour.
     */
    constructor(polygon, area) {
        this.polygon = polygon;
        this.area = area;
    }
    /**
     * Creates a Contour instance described by the contour JSON.
     *
     * @param contourJson The contour JSON
     */
    static fromJson(contourJson) {
        return new Contour(contourJson.Polygon.map((pointJson) => gl_matrix_1.vec2.fromValues(pointJson[0], pointJson[1])), contourJson.Area);
    }
    /**
     * Creates an JSON object out of the contour instance.
     */
    toJson() {
        return {
            // without that cast we are getting an TS2322 error?!
            Polygon: this.polygon.map((point) => [point[0], point[1]]),
            Area: this.area,
        };
    }
    /**
     * Test if the point is inside the contour or on the contour.
     *
     * @param point A 2D point
     */
    isPointInShape(point) {
        return ShapeHelper_1.ShapeHelper.isPointInShape(this.polygon, point) !== ShapeHelper_1.IsPointInShape.OutsideOfShape;
    }
    /**
     * Transform the contour by the given matrix.
     *
     * @param transform The transformation matrix.
     */
    transform(transform) {
        const transformedPolygon = this.polygon.map((point) => {
            const transformedPoint = gl_matrix_1.vec2.create();
            gl_matrix_1.vec2.transformMat2d(transformedPoint, point, transform);
            return transformedPoint;
        });
        const scaleX = transform[0];
        const scaleY = transform[3];
        const areaScale = Math.abs(scaleX * scaleY);
        const transformedArea = this.area * areaScale;
        return new Contour(transformedPolygon, transformedArea);
    }
}
exports.Contour = Contour;
//# sourceMappingURL=Contour.js.map